module.exports = {"pet":{"name":"Name","species":"Animal species","transponderId":"Transponder ID","birthdate":"Date of birth","veterinarian":"Veterinarian","custody":"Custody after my passing away","addressPlaceholder":"Name, address","notes":"Notes"},"addPet":{"title":"Enter pet","cancelButton":"Cancel"},"saveButton":"Save","deleteButton":"Delete","addPetAction":"Enter pet +","meta":"Pets"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/pets.json
// module id = aS4K
// module chunks = 1